(function () {
  if ( !isSmartPhone() ) {
    setTimeout("link()", 0);
  }
})();

function isSmartPhone() {
  if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    return true;
  } else {
    return false;
  }
}

function link(){
    location.href='https://aoyama-trading.co.jp/pages/mawahanger';
}